"use client";

import React from "react";

type AniButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "tertiary";
  /** Square at the size token rather than a padded label button. */
  iconOnly?: boolean;
};

const AniButton = ({
  variant = "primary",
  iconOnly = false,
  className,
  children,
  ...rest
}: AniButtonProps) => (
  <button
    type="button"
    data-token={
      `Ani Button/${variant[0].toUpperCase()}${variant.slice(1)}`
    }
    className={`ani-btn ani-btn--${variant}${iconOnly ? " ani-btn--icon-only" : ""}${className ? ` ${className}` : ""}`}
    {...rest}
  >
    {children}
  </button>
);

export default AniButton;
